"use client";
import React from "react";

export default function BrandsSkeleton() {
  return (
    <section className="py-5 bg-light">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-4">
          <div className="skeleton skeleton-title mx-auto mb-2"></div>
          <div className="skeleton skeleton-line mx-auto"></div>
        </div>

        {/* ===== Desktop Layout ===== */}
        <div className="d-none d-md-block">
          {/* Logos Row */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton skeleton-logo"></div>
            ))}
          </div>

          {/* Content Block */}
          <div className="bg-white text-white text-center p-5 rounded">
            <div className="skeleton skeleton-text mx-auto mb-2"></div>
            <div className="skeleton skeleton-text mx-auto mb-2"></div>
            <div className="skeleton skeleton-text mx-auto mb-2"></div>
            <div className="skeleton skeleton-text mx-auto mb-2"></div>

            <div className="skeleton skeleton-btn mx-auto mt-4"></div>
          </div>
        </div>

        {/* ===== Mobile Layout ===== */}
        <div className="d-block d-md-none">
          <div className="row g-0">

            {/* Left Logos */}
            <div className="col-4 border-end">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="skeleton skeleton-logo-mobile mb-3"
                ></div>
              ))}
            </div>

            {/* Right Content */}
            <div className="col-8">
              <div className="bg-white text-white p-3 h-100">
                <div className="skeleton skeleton-text mb-2"></div>
                <div className="skeleton skeleton-text mb-2"></div>
                <div className="skeleton skeleton-text mb-2"></div>

                <div className="skeleton skeleton-small mb-3"></div>

                <div className="skeleton skeleton-btn"></div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}